import {
  Component,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication/authentication.service';
import { AuthenticationContext } from '../../shared/services/authentication/authentication-context';
import { Router, RouterLink } from '@angular/router';
import { AliveService } from '@ui/global-shared/services';
import { Observable, Subscription } from 'rxjs';
import { TopbarState } from './topbar-state';
import { map, skipWhile, take } from 'rxjs/operators';
import { SupplierService } from '../../services/supplier/supplier.service';
import { SupplierRegistrationStateService } from '../../shared/services/registration-state/supplier-registration-state.service';
import { UserInfo } from '../../shared/services/authentication/user-info.model';
import { NgClass, AsyncPipe } from '@angular/common';
import { PublicHeaderComponent } from '../public-header/public-header.component';

@Component({
  selector: 'pt-b2b-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, RouterLink, PublicHeaderComponent, AsyncPipe],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private authService = inject(AuthenticationService);
  private authContext = inject(AuthenticationContext);
  private router = inject(Router);
  private aliveService = inject(AliveService);
  private supplierService = inject(SupplierService);
  private registrationStateService = inject(SupplierRegistrationStateService);
  topbarState = inject(TopbarState);

  userData: UserInfo | undefined = undefined;
  isSupplierActive$ = this.registrationStateService
    .getRegistrationState()
    .pipe(map((state) => state.supplierStatus === 'ACTIVE'));
  userInfo$: Observable<string>;
  private readonly subscriptions$ = new Subscription();
  private supplierName$: Observable<string>;

  constructor() {
    this.subscriptions$.add(
      this.authContext.getUserInformation().subscribe((val) => {
        this.userData = val;
      }),
    );
  }

  ngOnInit(): void {
    this.userInfo$ = this.authContext.getUserInformation().pipe(
      take(1),
      map(
        (userInfo) =>
          `${userInfo.contact.title || ''} ${userInfo.contact.fullname}`,
      ),
    );
    this.supplierName$ = this.supplierService.getMasterData().pipe(
      take(1),
      skipWhile((masterData) => !masterData),
      map((masterData) => `(${masterData.name})`),
    );
  }

  logout(): void {
    this.aliveService.stop();
    this.router.navigate(['login']); // implicitly logs out via LogoutGuard
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }

  userLoggedIn(): boolean {
    return !!this.userData;
  }
}
